<template>
  <v-chip label class="p-postWordsCounter">
    <span class="p-postWordsCounter__num">
      <AnimatedNumber
        :value="wordsCount"
        :format-value="formatWordsCount"
        :duration="300"
      />
    </span>
    文字
  </v-chip>
</template>

<script>
import { mapState } from 'vuex'
import AnimatedNumber from 'animated-number-vue'

export default {
  components: {
    AnimatedNumber
  },
  computed: {
    ...mapState({
      wordsCount: (state) => state.PostEditor.wordsCount
    })
  },
  mounted () {
    const subscribeMutationTypes = [
      'PostEditor/UPDATE_ITEM',
      'PostEditor/DELETE_ITEM'
    ]
    this.$store.subscribe((mutation) => {
      if (subscribeMutationTypes.includes(mutation.type)) {
        this.$store.dispatch('PostEditor/countPostWords')
      }
    })
  },
  methods: {
    formatWordsCount: function (value) {
      return `${value.toFixed(0)}`
    }
  }
}
</script>

<style scoped lang="sass">
.p-postWordsCounter
  &__num
    font-size: 1.1rem
    letter-spacing: 2px
</style>
